import { c as _c } from "react/compiler-runtime";
// biome-ignore lint/style/noRestrictedImports: this is fine
import { Button as DSButton } from "@opensea/ui-kit";
import { useButton } from "./useButton";
export function Button(t0) {
  const $ = _c(8);
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = ref;
  } else {
    props = $[1];
    ref = $[2];
  }
  const {
    renderLink,
    onClick
  } = useButton(props);
  let t1;
  if ($[3] !== onClick || $[4] !== props || $[5] !== ref || $[6] !== renderLink) {
    t1 = <DSButton renderLink={renderLink} {...props} onClick={onClick} ref={ref} />;
    $[3] = onClick;
    $[4] = props;
    $[5] = ref;
    $[6] = renderLink;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}